export enum MiscFileType {
  SETTLEMENT_AGREEMENT = "settlement_agreement",
  UCC_LIEN = "ucc_lien",
  JUDGMENT = "judgment",
  EMAIL_CHAIN = "email_chain",
  PAYMENT_HISTORY = "payment_history",
  ATTORNEY_LETTER = "attorney_letter",
  SCREENSHOTS = "screenshots",
  REDEMPTION_LETTER = "redemption_letter",
  FSP_LOAN_DOC = "fsp_loan_doc",
  OTHERS = "others",
}

export type MiscFile = {
  _id: string;
  application_id?: string;
  file_name: string;
  type: MiscFileType;
  s3_key: string;
  mime_type?: string;
  size?: number;
  uploaded_by?: string;
  notes?: string;
  meta?: Record<string, unknown>;
  alias?: string;
  createdAt: string;
  updatedAt: string;
  loan_id?: string;
  creditor_id?: string;
};
